import * as React from 'react';
import classNames from 'classnames';

import PATHS from '../../constants/paths';

import MPLink, { IMPLinkProps } from '../MPLink';
import IMPComponent from '../interfaces/IMPComponent';

import './styles.scss';

interface ILogoProps extends IMPComponent {
  iconColor?: 'cerulean' | 'grey';
  to?: string;
  children?: React.ReactNode;
}

const Logo: React.FunctionComponent<ILogoProps> = ({ iconColor, className, style, children, ...props }) => {
  const cn = classNames('Logo', className, {
    [`Logo--${iconColor}`]: Boolean(iconColor),
  });

  return (
    <div className={cn} style={style}>
      <MPLink {...(props as IMPLinkProps)}>
        <span className="Logo-icon" />
      </MPLink>
      {children}
    </div>
  );
};

Logo.defaultProps = {
  iconColor: 'cerulean',
  to: PATHS.HOME,
};

export default React.memo(Logo);



// WEBPACK FOOTER //
// ./src/components/Logo/index.tsx